import React, { useState, useContext } from 'react';
import { useNavigate, Link }            from 'react-router-dom';
import { AuthContext }                  from './AuthContext';
import './Login.css';

export default function Login() {
  // 取出新增的 loginWithGoogle 方法
  const { login, loginWithGoogle } = useContext(AuthContext);

  const [creds, setCreds]         = useState({ email: '', password: '' });
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError]         = useState('');
  const [loading, setLoading]     = useState(false);
  const navigate                  = useNavigate();

  const handleChange = e => {
    const { name, value } = e.target;
    setCreds(prev => ({ ...prev, [name]: value }));
    setError('');
  };

  const handleSubmit = async e => {
    e.preventDefault();
    if (!creds.email || !creds.password) {
      setError('Email and password are required.');
      return;
    }
    setLoading(true);
    try {
      await login(creds.email, creds.password);
      navigate('/home');        // 登录成功跳转
    } catch (err) {
      setError(err.message || 'Login failed.');
    } finally {
      setLoading(false);
    }
  };

  // Google 登录
  const handleGoogleLogin = async () => {
    try {
      setLoading(true);
      await loginWithGoogle();
      navigate('/home');
    } catch (err) {
      setError(err.message || 'Google login failed.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      {/* LEFT PANEL */}
      <div className="login-left">
        <img src="/images/logo4.jpg" alt="Logo" className="login-image" />
      </div>

      {/* RIGHT PANEL */}
      <div className="login-right">
        <div className="login-top">
          <div className="login-logo">Home of AI Agents</div>
        </div>

        <div className="login-content">
          <h1>Hello, welcome!</h1>
          {error && <div className="error-message">{error}</div>}

          <form className="login-form" onSubmit={handleSubmit}>
            <label htmlFor="email">Email</label>
            <input
              id="email"
              name="email"
              type="email"
              value={creds.email}
              onChange={handleChange}
              required
            />

            <label htmlFor="password">Password</label>
            <div className="password-field">
              <input
                id="password"
                name="password"
                type={showPassword ? 'text' : 'password'}
                value={creds.password}
                onChange={handleChange}
                required
              />
              <button
                type="button"
                className="toggle-password"
                onClick={() => setShowPassword(v => !v)}
                aria-label={showPassword ? 'Hide password' : 'Show password'}
              >
                {showPassword ? 'Hide' : 'Show'}
              </button>
            </div>

            <div className="remember-forgot">
              <label className="remember-me">
                <input type="checkbox" name="rememberMe" />
                <span>Remember me</span>
              </label>
              <Link to="/forgot-password" className="forgot-link">
                Forgot password?
              </Link>
            </div>

            <div className="auth-buttons">
              <button type="submit" className="login-button" disabled={loading}>
                {loading ? 'Logging in…' : 'Login'}
              </button>
              <Link to="/signup" className="signup-button">
                Sign Up
              </Link>
            </div>
          </form>

          {/* Google 登录按钮 */}
          <div className="social-login">
            <button className="google-login-btn" onClick={handleGoogleLogin} disabled={loading}>
              <img
                src="https://developers.google.com/identity/images/g-logo.png"
                alt="Google"
                className="google-icon"
              />
              Sign in with Google
            </button>
          </div>
        </div>

        <div className="login-footer">
          <p>Follow</p>
          <div className="social-icons">
            <a href="#!"><i className="fab fa-facebook-f" /></a>
            <a href="#!"><i className="fab fa-twitter" /></a>
            <a href="#!"><i className="fab fa-instagram" /></a>
          </div>
        </div>
      </div>
    </div>
  );
}
